import styled from 'styled-components';

const PageContainer = styled.div`
	display: inline-block;
	width: 100%;
	display: flex;
	padding: 0 24px 24px 24px;
	padding: ${(props) => props.padding};
	margin: ${(props) => props.margin};
	overflow: auto;
	overflow: ${(props) => props.Overflow};

	${({ flexColumn }) =>
		flexColumn &&
		`flex-direction: column;
    `};

	${({ AlignCenter }) =>
		AlignCenter &&
		`justify-content: center;
    `};

	${({ PaginationContainer }) =>
		PaginationContainer &&
		`display: inline-block;
    `};

	${({ onlyVerticalScroll }) =>
		onlyVerticalScroll &&
		`overflow-y: auto;
        overflow-x: hidden;
    `};
	${({ visitSummary }) =>
		visitSummary &&
		`padding:25px 150px 0px 150px;
		flex-direction: column;
			@media screen and (max-width: 768px) {
				padding:25px 0 0;

			}
    `};

	${({ onlyHorizontalScroll }) => onlyHorizontalScroll && `overflow-x: auto; overflow-y: hidden; `};

	${({ childFullHeight }) => childFullHeight && `display: inline-grid; `};
`;

export default PageContainer;
